/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  selectionList,
  selectedType,
  selectedSearchType,
  getAllDrugFamilies,
  getAllManufacturerDrugFamilies,
  getAllSpecificTheraClass,
  searchNDCs,
  getAllMarketBasket,
  getPopupSpecificTherapeuticClass,
  getPopupManufacturer,
  getPopupMarketBasket,
  popupFlag,
  errorMsg,
  getPopupLabeler,
  navigateDetails,
  getDrugFamilyDetails,
  getDrugFamilyDetailsByNDC,
  ndcDataStore,
  ndcNameStore,
} from './store/actions';
import {
  createFlag,
  resetDetails,
  clearErrors,
} from '../DrugFamilyDetails/store/actions';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  drugFamilyHead,
  drugSpecificTherapeuticHead,
  drugManufacturerHead,
  labelerHead,
  NDCTableHead,
  MarketBasketHead,
  PopupMarketBasketHead,
  PopupManufacturerHead,
  PopupTherapeuticHead,
} from './tableHead';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as Constants from '../../../../SharedModules/AppConstants';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import {
  NDC_ALREADY_ADDED,
  NDC_FOR_UC_NOT,
  ERR_SELECT_NDC_REMOVE,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import * as actionType from './store/actionTypes';
import * as actionTypes from '../DrugFamilyDetails/store/actionTypes';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const DrugFamily = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(true);
  const [showDialog, setShowDialog] = React.useState(false);
  const [columnDefs, setColumnDefs] = React.useState(drugFamilyHead);
  const [selection, setSelection] = React.useState('');
  const [radioList, setRadioList] = React.useState([]);
  const [errorPopup, setErrorPopup] = React.useState(false);
  const [leftFull, setLefFull] = React.useState(false);
  const [rightFull, setRightFull] = React.useState(false);
  const searchTypeList = [
    { name: Constants.NDC, value: Constants.NDC },
    { name: Constants.Name, value: Constants.Name },
    { name: Constants.Labeler, value: Constants.Labeler },
  ];
  const [searchType, setSearchType] = React.useState(Constants.Labeler);
  const [showMoveButtons, setShowMoveButtons] = React.useState(false);
  const [popupColumnDef, setPopupColumnDef] = React.useState([]);
  const [searchNDCName, setSearchNDCName] = React.useState('');
  const [searchNDCCode, setSearchNDCCode] = React.useState('');
  const [selectedNDC, setSelectedNDC] = React.useState([]);
  const [removeNDC, setRemoveNDC] = React.useState([]);
  const [leftTableAPI, setLeftTableAPI] = React.useState();
  const [rightTableAPI, setRightTableAPI] = React.useState();
  const [leftTableErr, setLeftTableErr] = React.useState(false);
  const [rightTableErr, setRightTableErr] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [leftNDCErr, setLeftNDCErr] = React.useState(false);
  const [fileName, setFileName] = React.useState('DrugFamily');

  const selection_list = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.selection_list
  );
  const selected_type = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.selected_type
  );
  const selected_search_type = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.selected_search_type
  );
  const table_data = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.table_data
  );
  const ndc_data = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.ndc_data
  );
  const ndc_name = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.ndc_name
  );
  const popup_table_data = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.popup_table_data
  );
  const popup_flag = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.popup_flag
  );
  const error_msg = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.error_msg
  );
  const left_table_data = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.left_table_data
  );
  const right_table_data = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.right_table_data
  );
  const navigate_details = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.navigate_details
  );
  const drug_family_details = useSelector(
    (state) => state?.sharedState?.DrugFamilySearchReducer?.drug_family_details
  );

  const clearMessages = () => {
    dispatch(errorMsg([]));
    tabHighLigther(Constants.DRUG_FAMILY_ROUTE, false);
    setLeftTableErr(false);
    setRightTableErr(false);
    setLeftNDCErr(false);
  };

  const moveToDetails = () => {
    if (selected_type === Constants.CREATE_NEW_ID) {
      dispatch(selectedType(selection));
      dispatch(resetDetails());
      dispatch(createFlag(true));
    } else {
      dispatch(clearErrors());
      dispatch(createFlag(false));
      localStorage.setItem('updatedetails', true);
    }
    redirectURLLink(
      '/drugFamilyDetail',
      'View Drug Family Details',
      props.history
    );
  };

  const frameworkComponents = {
    FullNameRender: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'Drug Family Name') {
        name = cellInfo.data.familyName;
      }
      if (cellInfo?.colDef?.headerName === 'Drug Name') {
        name = cellInfo.data.drugName;
      }
      if (name && name.length > 15) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name && `${name}`}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  React.useEffect(() => {
    dispatch(selectionList());
  }, []);

  React.useEffect(() => {
    setRadioList(selection_list);
  }, [selection_list]);

  React.useEffect(() => {
    setSearchNDCCode(ndc_data);
  }, [ndc_data]);

  React.useEffect(() => {
    setSearchNDCName(ndc_name);
  }, [ndc_name]);

  React.useEffect(() => {
    setSearchType(selected_search_type);
    setShowMoveButtons(selected_search_type !== Constants.NDC);
  }, [selected_search_type]);

  React.useEffect(() => {
    setSelection(selected_type);
    setLoading(true);
    if (selected_type === Constants.DRUG_FAMILY_ID) {
      setColumnDefs(drugFamilyHead);
      setFileName('DrugFamily');
      dispatch(getAllDrugFamilies());
    } else if (selected_type === Constants.MANUFACTURER_ID) {
      setColumnDefs(drugManufacturerHead);
      setFileName('Manufacturer');
      dispatch(getAllManufacturerDrugFamilies());
    } else if (selected_type === Constants.SPECIFIC_THERAPEUTIC_CLASS_ID) {
      setColumnDefs(drugSpecificTherapeuticHead);
      setFileName('SpecificTherapeuticClass');
      dispatch(getAllSpecificTheraClass());
    } else if (selected_type === Constants.SPECIFIC_DRUG_ID) {
      setColumnDefs(labelerHead);
      dispatch(searchNDCs({ searchType: 'labeler' }, Constants.Labeler));
      setFileName('specificdrug-labeler');
    } else if (selected_type === Constants.MARKET_BASKET_ID) {
      setColumnDefs(MarketBasketHead);
      setFileName('MarketBasket');
      dispatch(getAllMarketBasket());
    } else if (selected_type === Constants.CREATE_NEW_ID) {
      moveToDetails();
    }
  }, [selected_type]);

  React.useEffect(() => {
    if (left_table_data.length > 0 || right_table_data.length > 0) {
      setLoading(false);
    }
  }, [left_table_data, right_table_data]);

  React.useEffect(() => {
    if (table_data) setLoading(false);
  }, [table_data]);

  React.useEffect(() => {
    if (error_msg.length > 0) {
      setLoading(false);
      tabHighLigther(Constants.DRUG_FAMILY_ROUTE, true);
    }
  }, [error_msg]);

  React.useEffect(() => {
    if (popup_flag) {
      setLoading(false);
      dispatch(popupFlag(false));
      if (popup_table_data.length == 1) {
        setLoading(true);
        dispatch(
          getDrugFamilyDetails({
            familySeqNum: popup_table_data[0].familySeqNum,
          })
        );
      } else if (popup_table_data.length > 1) {
        setShowDialog(true);
      } else {
        dispatch(errorMsg([Constants.SELECTION_NOT_MATCH]));
      }
    }
  }, [popup_table_data]);

  React.useEffect(() => {
    if (navigate_details) {
      dispatch(navigateDetails(false));
      setLoading(false);
      moveToDetails();
    }
  }, [navigate_details]);
  React.useEffect(() => {
    if (drug_family_details) {
      const { status, message } = drug_family_details;
      if (message === 'SUCESS' && status === '001') {
        dispatch({
          type: actionType.DRUG_FAMILY_DAETAILS,
          payload: null,
        });
        if (drug_family_details?.drugFamilyVOs?.length === 0) {
          setLoading(false);
          setErrorPopup(true);
        } else if (
          drug_family_details?.drugFamilyWrapperVO?.drugFamilyVO?.length === 0
        ) {
          dispatch(errorMsg([Constants.SELECTION_NOT_MATCH]));
        } else if (drug_family_details?.drugFamilyVOs?.length > 1) {
          setPopupColumnDef(drugFamilyHead);
          dispatch(popupFlag(true));
          dispatch({
            type: actionType.POPUP_TABLE_DATA,
            payload: drug_family_details.drugFamilyVOs,
          });
        } else {
          moveToDetails();
        }
      }
    }
  }, [drug_family_details]);

  const onSelectionChanged = (val) => {
    clearMessages();
    if (selected_type === Constants.SPECIFIC_DRUG_ID) {
      const [selectedRows] = val.api.getSelectedRows();
      dispatch({ type: actionType.RIGHT_TABLE_DATA, payload: [] });
      dispatch({ type: actionType.SEARCH_LEFT_TABLE_DATA, payload: [] });
      setLoading(true);
      dispatch(getPopupLabeler({ labelerCode: selectedRows.labelerCode }));
    }
  };

  const cellClickedListener = (val) => {
    const [selectedRows] = val.api.getSelectedRows();
    if (selected_type === Constants.MANUFACTURER_ID) {
      setPopupColumnDef(PopupManufacturerHead);
      setLoading(true);
      dispatch(popupFlag(true));
      dispatch(getPopupManufacturer({ mfgId: selectedRows?.mfgId }));
    } else if (selected_type === Constants.SPECIFIC_THERAPEUTIC_CLASS_ID) {
      setPopupColumnDef(PopupTherapeuticHead);
      setLoading(true);
      dispatch(popupFlag(true));
      dispatch(
        getPopupSpecificTherapeuticClass({
          specificTheraClass: selectedRows?.specificTheraClass,
        })
      );
    } else if (selected_type === Constants.MARKET_BASKET_ID) {
      setPopupColumnDef(PopupMarketBasketHead);
      setLoading(true);
      dispatch(popupFlag(true));
      dispatch(
        getPopupMarketBasket({
          marketBasketSeqNumber: selectedRows?.marketBasketSeqNum,
        })
      );
    } else if (selected_type === Constants.DRUG_FAMILY_ID) {
      setLoading(true);
      dispatch(
        getDrugFamilyDetails({
          familySeqNum: selectedRows.familySeqNum,
        })
      );
    }
  };

  const cellClickedListenerInDialog = (val) => {
    const [selectedRows] = val.api.getSelectedRows();
    setLoading(true);
    dispatch(getDrugFamilyDetails({ familySeqNum: selectedRows.familySeqNum }));
  };

  const onSelectionChangedLeft = (val) => {
    const selectedRows = val.api.getSelectedRows();
    if (selectedRows.length > 0) {
      clearMessages();
    }
    setSelectedNDC(selectedRows);
  };

  const onSelectionChangedRight = (val) => {
    const selectedRows = val.api.getSelectedRows();
    if (selectedRows.length > 0) {
      clearMessages();
    }
    setRemoveNDC(selectedRows);
  };

  const onLeftGridReady = (params) => {
    setLeftTableAPI(params.api);
  };

  const onRightGridReady = (params) => {
    setRightTableAPI(params.api);
  };

  const moveToLeft = () => {
    if (rightTableAPI) rightTableAPI.deselectAll();
    if (leftTableAPI) leftTableAPI.deselectAll();
    setLeftTableErr(false);
    if (removeNDC.length === 0) {
      setRightTableErr(true);
      dispatch(errorMsg([ERR_SELECT_NDC_REMOVE]));
    } else {
      const rmNDC = removeNDC.map((obj) => obj.ndc);
      const results = right_table_data.filter(
        (obj) => rmNDC.indexOf(obj.ndc) === -1
      );
      dispatch({ type: actionType.RIGHT_TABLE_DATA, payload: results });
    }
  };

  const moveToRight = () => {
    setRemoveNDC([]);
    if (rightTableAPI) rightTableAPI.deselectAll();
    if (leftTableAPI) leftTableAPI.deselectAll();
    setRightTableErr(false);
    if (selected_search_type === Constants.NDC) {
      setLeftNDCErr(true);
      if (searchNDCCode.length < 11) {
        dispatch(errorMsg([Constants.VALID_NDC_ERR]));
      } else {
        dispatch(ndcDataStore(searchNDCCode));
        dispatch(
          searchNDCs(
            { searchType: 'ndc', ndcOrName: searchNDCCode },
            Constants.NDC,
            right_table_data
          )
        );
      }
    } else if (selectedNDC.length === 0) {
      setRightTableErr(false);
      setLeftTableErr(true);
      dispatch(errorMsg([ERR_SELECT_NDC_REMOVE]));
    } else {
      leftTableAPI.deselectAll();
      const rlist = right_table_data.map((obj) => obj.ndc);
      const indexes = selectedNDC.map((val) => rlist.indexOf(val.ndc));
      const mapping = [...new Set(indexes)];
      if (mapping.length > 1 || (mapping.length === 1 && mapping[0] !== -1)) {
        dispatch(errorMsg([NDC_ALREADY_ADDED]));
        setLeftTableErr(true);
      } else {
        dispatch({
          type: actionType.RIGHT_TABLE_DATA,
          payload: [...right_table_data, ...selectedNDC],
        });
      }
    }
  };

  const moveAllToLeft = () => {
    if (rightTableAPI) rightTableAPI.deselectAll();
    if (leftTableAPI) leftTableAPI.deselectAll();
    dispatch({ type: actionType.RIGHT_TABLE_DATA, payload: [] });
  };

  const moveAllToRight = () => {
    if (rightTableAPI) rightTableAPI.deselectAll();
    if (leftTableAPI) leftTableAPI.deselectAll();
    dispatch({
      type: actionType.RIGHT_TABLE_DATA,
      payload: [...left_table_data],
    });
  };

  const viewDrugFamily = () => {
    setRightTableErr(true);
    setLeftTableErr(false);
    setLeftNDCErr(false);
    if (removeNDC.length === 1) {
      setLoading(true);
      dispatch(
        getDrugFamilyDetailsByNDC({
          drugSeqNum: removeNDC[0].drugSeqNum,
        })
      );
    } else if (removeNDC.length === 0) {
      dispatch(errorMsg([Constants.DRUG_SELECTION_NULL_ERR]));
    }
  };

  return (
    <div className="tabs-container">
      <Spinner load={loading} />
      {error_msg.length > 0 && (
        <DisplayErrorMessages errorMessages={error_msg} />
      )}
      <div className="tBillPanel custom-check frr-df">
        {!fullScreenView && !leftFull && !rightFull && (
          <div className="paneldevider-line">
            <CustomSeparator parent1="Maintain" parent2="DrugFamily" />
            <div className="panel mb-3">
              <div className="row">
                <div className="col-12 frr-radio-auto-width">
                  <RadioGroupComponent
                    labelName="Selection"
                    optionList={radioList || []}
                    filterAction={(e) => {
                      dispatch(selectedType(e));
                      dispatch(ndcDataStore(''));
                      dispatch(ndcNameStore(''));
                      dispatch({
                        type: actionType.RIGHT_TABLE_DATA,
                        payload: [],
                      });
                      dispatch({
                        type: actionType.SEARCH_LEFT_TABLE_DATA,
                        payload: [],
                      });
                      clearMessages();
                    }}
                    defaultValue={selection}
                  />
                </div>
              </div>
              {selected_type === Constants.SPECIFIC_DRUG_ID && (
                <div className="row">
                  <div className="col-12 mt-3">
                    <RadioGroupComponent
                      labelName="Search Type"
                      data-testId="search_radio"
                      optionList={searchTypeList || []}
                      filterAction={(e) => {
                        dispatch(selectedSearchType(e));
                        dispatch(ndcNameStore(''));
                        dispatch(ndcDataStore(''));
                        dispatch({
                          type: actionType.SEARCH_LEFT_TABLE_DATA,
                          payload: [],
                        });
                        dispatch({
                          type: actionType.RIGHT_TABLE_DATA,
                          payload: [],
                        });
                        clearMessages();
                      }}
                      defaultValue={searchType}
                    />
                  </div>
                </div>
              )}
              <div className="clearfix" />
            </div>
          </div>
        )}
        {!(
          selected_type === Constants.SPECIFIC_DRUG_ID &&
          (selected_search_type === Constants.NDC ||
            selected_search_type === Constants.Name)
        ) &&
          !leftFull &&
          !rightFull && (
            <TableGrid
              rowData={table_data}
              data-testId="details-table"
              columnDefs={columnDefs}
              gridHeight={fullScreenView ? '70vh' : 400}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={() =>
                setFullScreenView(!fullScreenView)
              }
              frameworkComponents={frameworkComponents}
              navigateToNextCell={navigateToNextCell}
              onSelectionChanged={onSelectionChanged}
              cellClickedListener={cellClickedListener}
              // tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              exportFile
              fileName={fileName}
              helpMessage={
                selected_type !== Constants.SPECIFIC_DRUG_ID
                  ? Constants.DOUBLE_CLICK_INFO
                  : ''
              }
            />
          )}
        <div className="FRR-custom-table">
          {!leftFull && !rightFull && (
            <div className="tab-header display-inline-flex">
              {selected_type === Constants.SPECIFIC_DRUG_ID &&
                (selected_search_type === Constants.NDC ||
                  selected_search_type === Constants.Labeler) && (
                  <div className="clearfix" />
                )}
              {!fullScreenView &&
                selected_type === Constants.SPECIFIC_DRUG_ID &&
                selected_search_type === Constants.Name && (
                  <div className="selectedByName">
                    <TextField
                      data-testid="NDC-search-input"
                      placeholder="Search..."
                      label="search"
                      id="searchNdc"
                      variant="outlined"
                      className="searchInput frr-display-hidden-label"
                      value={searchNDCName}
                      inputProps={{ id: 'searchNdc' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => setSearchNDCName(e.target.value)}
                    />
                    <div className="float-right btn-wrapper pt-1">
                      <Button
                        className="btn btn-success btn-search ml-1"
                        data-testid="ndc-search-btn"
                        onClick={() => {
                          dispatch({
                            type: actionType.SEARCH_LEFT_TABLE_DATA,
                            payload: [],
                          });
                          clearMessages();
                          if (searchNDCName !== '') {
                            setLoading(true);
                            dispatch(
                              searchNDCs(
                                {
                                  searchType: 'name',
                                  ndcOrName: searchNDCName,
                                },
                                Constants.Name
                              )
                            );
                            dispatch(ndcNameStore(searchNDCName));
                          } else {
                            dispatch(ndcNameStore(''));
                            dispatch(errorMsg([NDC_FOR_UC_NOT]));
                            dispatch({
                              type: actionType.RIGHT_TABLE_DATA,
                              payload: [],
                            });
                          }
                        }}
                      >
                        <SVGComponent iconName="Icon-search" /> {'  '} Search
                      </Button>
                    </div>
                  </div>
                )}
              {!fullScreenView &&
                selected_type === Constants.SPECIFIC_DRUG_ID && (
                  <div className="float-right btn-wrapper pt-1" tabIndex={0}>
                    <Button
                      className="btn btn-success btn-search ml-1"
                      data-testid="view-drug-btn"
                      onClick={viewDrugFamily}
                    >
                      <SVGComponent iconName="Icon-search" /> {'  '} View Drug
                      Family
                    </Button>
                  </div>
                )}
            </div>
          )}
          {!fullScreenView && selected_type === Constants.SPECIFIC_DRUG_ID && (
            <>
              <div className="row row_wrp">
                <div style={!leftFull ? { width: '47%' } : { width: '100%' }}>
                  {!leftFull &&
                    !rightFull &&
                    selected_search_type === Constants.NDC && (
                      <div
                        className="selectedByNDCs"
                        style={{ padding: '30% 10%' }}
                      >
                        <label
                          className="ndcLabel"
                          htmlFor="standard-reason-code"
                        >
                          Enter NDC to be added
                        </label>
                        <TextField
                          variant="outlined"
                          className="searchInput"
                          value={searchNDCCode}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') moveToRight();
                          }}
                          inputProps={{
                            maxLength: 13,
                            id: 'standard-reason-code-ndc',
                          }}
                          onChange={(e) => {
                            clearMessages();
                            setSearchNDCCode(e.target.value);
                          }}
                          helperText={Constants.NDC_FORMAT_MSG}
                        />
                        {leftNDCErr && (
                          <DisplayErrorMessages errorMessages={error_msg} />
                        )}
                      </div>
                    )}
                  {!rightFull && selected_search_type !== Constants.NDC && (
                    <>
                      {leftTableErr && (
                        <DisplayErrorMessages errorMessages={error_msg} />
                      )}
                      <TableGrid
                        data-testid="NDC-LeftTable"
                        rowData={left_table_data}
                        gridCall={onLeftGridReady}
                        columnDefs={NDCTableHead}
                        fullScreenView={leftFull}
                        handleFullScreenViewClick={() => setLefFull(!leftFull)}
                        gridHeight={leftFull ? '70vh' : 340}
                        rowSelection="multiple"
                        fileName="NDC List"
                        exportFile
                        onSelectionChanged={onSelectionChangedLeft}
                        frameworkComponents={frameworkComponents}
                      />
                    </>
                  )}
                </div>
                {!leftFull && !rightFull && (
                  <div className="ndcsTableSection task_request_claim">
                    <div className="ndcTableBtn">
                      <Button
                        className="btn-primary frr-arrow-button"
                        onClick={moveToRight}
                        aria-label="single data forward"
                        data-testid="move-left-to-right-btn"
                        tabIndex={0}
                      >
                        <i
                          className="fa fa-light fa-caret-right"
                          aria-hidden="true"
                        />
                      </Button>
                      {showMoveButtons && (
                        <Button
                          className="btn-primary"
                          onClick={moveAllToRight}
                          aria-label="All data forward"
                          data-testid="move-all-left-to-right-btn"
                          tabIndex={0}
                        >
                          <i
                            className="fa fa-light fa-forward"
                            aria-hidden="true"
                          />
                        </Button>
                      )}
                      {showMoveButtons && (
                        <Button
                          className="btn-primary"
                          onClick={moveAllToLeft}
                          aria-label="All data backward"
                          data-testid="move-all-right-to-left-btn"
                          tabIndex={0}
                        >
                          <i
                            className="fa fa-light fa-backward"
                            aria-hidden="true"
                          />
                        </Button>
                      )}
                      <Button
                        className="btn-primary"
                        onClick={moveToLeft}
                        aria-label="single data backward"
                        data-testid="move-right-to-left-btn"
                        tabIndex={0}
                      >
                        <i
                          className="fa fa-light fa-caret-left"
                          aria-hidden="true"
                        />
                      </Button>
                    </div>
                  </div>
                )}
                {!leftFull && (
                  <div
                    style={!rightFull ? { width: '47%' } : { width: '100%' }}
                  >
                    {rightTableErr && (
                      <DisplayErrorMessages errorMessages={error_msg} />
                    )}
                    <TableGrid
                      data-testid="NDC-RightTable"
                      rowData={right_table_data}
                      columnDefs={NDCTableHead}
                      fullScreenView={rightFull}
                      handleFullScreenViewClick={() => setRightFull(!rightFull)}
                      gridHeight={rightFull ? '70vh' : 340}
                      rowSelection="single"
                      gridCall={onRightGridReady}
                      onSelectionChanged={onSelectionChangedRight}
                      fileName="NDC List"
                      exportFile
                      frameworkComponents={frameworkComponents}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <ModalDialog
          open={showDialog}
          closeModal={setShowDialog}
          dialogTitle={Constants.DRUG_FAMILY_POPUP_TITLE}
          grid={
            <TableGrid
              rowData={popup_table_data}
              gridHeight={Constants.GRID_HEIGHT}
              columnDefs={popupColumnDef}
              exportFile
              fileName="Drug Family"
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              childPopup
              cellClickedListener={cellClickedListenerInDialog}
              helpMessage={Constants.DOUBLE_CLICK_INFO}
            />
          }
          cancelAction={setShowDialog}
        />
        <CommonModal
          open={errorPopup}
          viewAction
          viewHeader
          className="dialog-420"
          onOk={() => setErrorPopup(false)}
          okTitle="Ok"
          modalTitle={Constants.SELECT_DRUG_FAMILY}
          childrenComponent={Constants.DRUG_FAMILY_NULL_ERR.replace(
            '{NDC}',
            removeNDC?.[0]?.ndc
          )}
        />
      </div>
    </div>
  );
};

export default DrugFamily;
